import { Navigate, NavigateProps } from 'react-router-dom';
import { useToWithQuery } from '../hooks';

export default function NavigateWithQuery(props: NavigateProps) {
  const { to, ...rest } = props;
  const toWithQuery = useToWithQuery(to);

  return <Navigate to={toWithQuery} {...rest} />;
}
